import React, {useMemo, useState } from "react";
import AFilterForm from "../../.../../../../../components/AFilterForm/AFilterForm";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import { getAppliedFilterCount } from "../../../cash-management/receipt/hooks/useFilterCount";
import FilterCountBadge from "../../../cash-management/components/FilterCountBadge";

const btnStyle = {
  fontFamily: "Gilroy-Bold",
  color: "black",
};
const activeBtn = {
  fontFamily: "Gilroy-Bold",
  color: "#00B0F5",
};



const ReceiptFilterDrawer = ({
  applyFilterHandler,
  onRemoveFilterHandler,
  dropdownValues,
  appliedForm = {},
}) => {
  const [filterForm, setFilterForm] = useState({});

  const handleFilterForm = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };


  const removeFilterHandler = () => {
    onRemoveFilterHandler();
    setFilterForm({});
  };

  const formConfig = useMemo(()=>{
    return ([


      {
        label: "Course ID",
        type: "select",
        formKey: "courseId",
        items: dropdownValues.courseIds,
        placeholder: "Select",
        colSpan: 2,
        isMulti: false,
      },

      {
        label: "Term",
        type: "select",
        formKey: "term",
        items: dropdownValues.terms,
        placeholder: "Select",
        colSpan: 2,
        isMulti: false,
      },

       {
        label: "Receipt Date from",
        type: "date",
        formKey: "receiptDateFrom",
        placeholder: "Select Date",
        colSpan: 2,
        maxDate:filterForm?.receiptDateTo
      },
      {
        label: "Receipt Date to",
        type: "date",
        formKey: "receiptDateTo",
        placeholder: "Select Date",
        colSpan: 2,
        minDate: filterForm?.receiptDateFrom
        
      },
      {
        label: "Cheque Date from",
        type: "date",
        formKey: "chequeDateFrom",
        placeholder: "Select Date",
        colSpan: 2,
        maxDate:filterForm?.chequeDateTo
      },
      {
        label: "Cheque Date to",
        type: "date",
        formKey: "chequeDateTo",
        placeholder: "Select Date",
        colSpan: 2,
        minDate: filterForm?.chequeDateFrom
      }   
    ])
  }, [dropdownValues, filterForm])

  const appliedFilterCount = useMemo(
      () => getAppliedFilterCount(appliedForm, formConfig),
      [appliedForm, formConfig]
    );
  

  return (
    <AFilterForm
      btnComponent={
        <div>
        <AButton
          updatedStyle={appliedFilterCount > 0 ? activeBtn : btnStyle}
          variant={appliedFilterCount > 0 ? "outline" : "general"}
          size="xs"
          className="no-ml-btn"
        >
          Filters
        </AButton>
        <FilterCountBadge count={appliedFilterCount} />
        </div>
      }
      formFields={formConfig}
      filterForm={filterForm}
      handleFilterForm={handleFilterForm}
      applyFilterHandler={applyFilterHandler}
      removeFilterHandler={removeFilterHandler}
    />
  );
};

export default ReceiptFilterDrawer;
